module.exports = __webpack_public_path__ + "img/av_polar bear.3e1fa612.png";